@if (isHeader || !deviceGroup) {
  <th>{{ "devices.list.name" | translate }}</th>
  <th>{{ "devices.list.currentValue" | translate }}</th>
  <th>{{ "devices.list.model" | translate }}</th>
  <th></th>
} @else {
  @if (deviceGroupView$ | async; as view) {
    <td class="icon-cell">
      <button
        type="button"
        class="button icon-button"
        (click)="onToggleExpanded()"
      >
        @if (isExpanded) {
          <app-icon name="ic_chevron_up" />
        } @else {
          <app-icon name="ic_chevron_down" />
        }
      </button>
    </td>
    <th colspan="3">
      <p class="flex">
        {{ view.deviceGroup.name }}
        @if (view.deviceGroup.isFavorite) {
          <app-icon class="color-favorite" name="ic_star_filled" />
        }
      </p>
    </th>
    <td>
      <app-tag>
        {{
          LabelConverter.getDeviceGroupStateLabel(view.deviceGroup.state)
            | translate
              : (view.deviceGroup.state === DeviceGroupState.PARTIALLY_ACTIVE
                  ? {
                      activeCount: view.activeDeviceCount,
                      count: view.deviceCount,
                    }
                  : {})
        }}
      </app-tag>
    </td>
    <td class="icon-cell">
      <app-context-menu [menuItems]="contextMenu" />
    </td>
  }
}
